// src/firebase.js
import { getAuth, GoogleAuthProvider, signInWithPopup } from 'firebase/auth';
import { initializeApp } from 'firebase/app';


// Your Firebase configuration (found in Firebase Console > Project Settings > Web App)
const firebaseConfig = {
  apiKey: "AIzaSyCwiNsELwG4hLNtJ0cxUGnRyStBqzB47H0",
  authDomain: "allfileconverters.firebaseapp.com",
  projectId: "allfileconverters",
  storageBucket: "allfileconverters.firebasestorage.app",
  messagingSenderId: "648719922644",
  appId: "1:648719922644:web:8538ca7cd847d0cba51241",
  measurementId: "G-07YK31DXKM"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const auth = getAuth(app);
const provider = new GoogleAuthProvider();

export { auth, provider };


